import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "rsuite";
import { useTranslation } from "react-i18next";
import "./itemBusiness.scss";

export const ItemBusiness = (props) => {
  const setCompany = () => {
    sessionStorage.setItem("rp_company", props.id);
  };
  const { t } = useTranslation();
  return (
    <div className="item_business cards">
      <span className="item_ico_ttl">
        <Icon icon="building-o"></Icon>
      </span>
      <div className="box_ttls_business">
        <h4 className="ttls__business">{props.name}</h4>
        <p className="fw-300 businessActivity">{props.businessActivity}</p>
      </div>
      <div className="box_actions_go">
        <span>
          <Icon icon="user" /> {props.usersCount}
        </span>
        <Link to="/home" className="btn_link" onClick={setCompany}>
          {t('itemBusiness.enter')} <Icon icon="angle-right"></Icon>
        </Link>
      </div>
    </div>
  );
};
